import { BrowserModule } from '@angular/platform-browser';
import { NgModule, ApplicationRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { AgmCoreModule } from '@agm/core';
/*import { GoogleModule } from './google/google.module';

import { AngularFireModule, FirebaseAppConfig } from 'angularfire2';
import { AngularFireAuthModule } from 'angularfire2/auth';
import { AngularFireDatabaseModule } from 'angularfire2/database';
*/

import { AppComponent } from './app.component';
import { CarteMarialeComponent } from './components/carte-mariale.component';
import { PiedDePageComponent } from './components/pied-de-page.component';
import { MenuNavigationComponent } from './components/menu-navigation.component';
import { CarteComponent } from './components/carte.component';
import { EnteteComponent } from './components/entete.component';
import { RechercheComponent } from './components/recherche.component';
import { InformationComponent } from './components/information.component';
import { MarqueurInfoComponent } from './components/marqueur-info.component';
import { AProposComponent } from './components/a-propos.component';
import { MentionsLegalesComponent } from './components/mentions-legales.component';
import { InfoLegendeComponent } from './components/info-legende.component';
import { FiltreComponent } from './components/filtre.component';
import { RechercheResultatComponent } from './components/recherche-resultat.component';
import { FavorisComponent } from './components/favoris.component';
import { MenuMobileComponent } from './components/menu-mobile.component';
import { DonneeService } from './services/donnee.service';

/*
export const firebaseConfig: FirebaseAppConfig = {
    apiKey: "AIzaSyA7R7cgLM4Gb1-QiIfIBy7VVS_-5cbnRCo",
    authDomain: "carte-mariale.firebaseapp.com",
    databaseURL: "https://carte-mariale.firebaseio.com",
    projectId: "carte-mariale",
    storageBucket: "carte-mariale.appspot.com",
    messagingSenderId: "974538992073"
  };*/

@NgModule({
  imports: [
    BrowserModule,
    CommonModule,
    FormsModule,
    HttpModule,
    BrowserAnimationsModule,
    AgmCoreModule.forRoot({
      apiKey: 'AIzaSyAv5xs9SIu2ZVaR1pPX1rAfHhxK7cAT6IA'
    }),
    /*AngularFireModule.initializeApp(firebaseConfig),
    AngularFireAuthModule,
    AngularFireDatabaseModule*/
  ],
  declarations: [
    AppComponent,
    CarteMarialeComponent,
    PiedDePageComponent,
    MenuNavigationComponent,
    CarteComponent,
    EnteteComponent,
    RechercheComponent,
    InformationComponent,
    MarqueurInfoComponent,
    AProposComponent,
    MentionsLegalesComponent,
    InfoLegendeComponent,
    FiltreComponent,
    RechercheResultatComponent,
    FavorisComponent,
    MenuMobileComponent
  ],
  providers: [
    DonneeService
  ],
  bootstrap: [ AppComponent ]
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts